export default __webpack_public_path__ + "media/images/happy-dog-decor-75bc0d5bdeda939b2ef520b44e84c53c.png";